import { IListRegionTag } from '@cbgms/api'

export const prepareRegionsDataForCombobox = (regions: IListRegionTag[]) => {
  return regions.map(region => {
    const {
      Region,
      Region: { UUID, Name }
    } = region

    return {
      text: Name,
      value: UUID,
      key: UUID,
      ...Region
    }
  })
}
